/*
 * ototo-ds-related.js — fills ds-related ("You may also like") on the PDP.
 *
 * Shopify only resolves `recommendations` in a section rendered through the
 * recommendations endpoint, so the page ships an empty body and this fetches the
 * same section by id once it is near the viewport. The rendered rail is lifted
 * out of the response and dropped in; ototo-ds-rails.js then binds its arrows
 * and the cards' galleries. No products → the whole section goes, rather than
 * leaving a heading over nothing.
 */
(function () {
  'use strict';

  function fill(section) {
    if (section.dataset.otRelatedDone) return;
    section.dataset.otRelatedDone = '1';
    var body = section.querySelector('[data-ot-related-body]');
    fetch(section.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var got = doc.querySelector('[data-ot-related-body]');
        if (!got || !got.querySelector('.ot-card')) { section.remove(); return; }
        body.innerHTML = got.innerHTML;
        if (window.__otDsRailsInit) window.__otDsRailsInit();
      })
      .catch(function () { section.remove(); });
  }

  function boot() {
    document.querySelectorAll('[data-ot-related]').forEach(function (section) {
      if (section.querySelector('[data-ot-related-body] .ot-card')) return; // already rendered (editor preview)
      if (!('IntersectionObserver' in window)) { fill(section); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fill(section);
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
